import { BuiltinInterface } from '../BuiltinInterface';
class PropertyDescriptorInterface extends BuiltinInterface {
    constructor() {
        super(...arguments);
        this.canImplement = true;
    }
}
export const add = (builtins) => {
    builtins.addInterface('PropertyDescriptor', new PropertyDescriptorInterface());
};

//# sourceMappingURL=index.js.map
